import { Check } from 'lucide-react'
import type { GameTier } from '../../gameTier'

interface ResultTagProps {
  tier: GameTier
  /** An auto pick names itself rather than borrowing a result tag: it never got close,
   * never missed, never called anything — the deadline filled it. */
  isAuto?: boolean
}

/** The tag every scored card opens with. Same element and classes on both grids, so a
 * fixture's card is the same height wherever it is rendered. */
export function ResultTag({ tier, isAuto = false }: ResultTagProps) {
  return (
    <p className="game-card__ft-tag">
      {isAuto ? (
        'AUTO PICK'
      ) : tier === 'win' ? (
        'EXACT SCORE'
      ) : tier === 'blue' ? (
        <>
          <span className="game-card__ft-tag-text">CORRECT CALL</span>
          <span className="game-card__check-stamp" aria-hidden="true">
            <Check />
          </span>
        </>
      ) : tier === 'muted' ? (
        'CLOSE'
      ) : (
        'MISS'
      )}
    </p>
  )
}
